"use client";

import { NKCurrencyInput } from "@/components/nk/currency-input";

/* ──────────────────────────────────────────────────────────────────────────
 * IncomeInput — currency field for gross annual income.
 *
 * Thin wrapper around NKCurrencyInput. Treats blank / zero / negative as
 * "no value entered yet" (passes through `undefined` to the parent) so the
 * tax-savings section can display "Enter your income to see potential
 * savings" instead of a fake $0 calculation.
 *
 * No default value — per the no-assumed-values doctrine, we don't pick an
 * income for the user. The placeholder hints at the shape they should enter.
 * ────────────────────────────────────────────────────────────────────────── */

export interface IncomeInputProps {
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  disabled?: boolean;
}

export function IncomeInput({ value, onChange, disabled }: IncomeInputProps) {
  return (
    <NKCurrencyInput
      value={value ?? ""}
      onChange={(v) => {
        if (v === undefined || v <= 0) {
          onChange(undefined);
          return;
        }
        onChange(v);
      }}
      currency="CAD"
      disabled={disabled}
      placeholder="Combined household income"
      className="font-display h-9 text-lg font-medium"
    />
  );
}
